import { NxPopoverTriggerDirective } from "@allianz/ng-aquila/popover";
import { Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
  selector: "[appNxPopoverController]",
  standalone: true,
})
export class NxPopoverControllerDirective {
  private popoverOpen: boolean = false;
  private readonly isMouseEnter: boolean = false;
  private isMobile: boolean = false;

  constructor(private readonly eleRef: ElementRef) {}

  @Input("appNxPopoverController")
  public popoverTarget: NxPopoverTriggerDirective;

  @HostListener("click") public onMouseDown() {
    this.popoverOpen = !this.popoverOpen;
    this.popoverFunction();
  }

  @HostListener("touchstart") public onTouchStart() {
    this.isMobile = true;
  }

  @HostListener("mouseenter") public onMouseEnter() {
    if (!this.isMobile) {
      this.popoverOpen = true;
      this.popoverFunction();
    }
  }

  @HostListener("mouseleave") public onMouseLeave() {
    this.popoverOpen = false;
    this.popoverFunction();
  }

  private popoverFunction() {
    if (this.popoverOpen) {
      this.popoverTarget.open();
      this.popoverTarget.updatePosition();
      this.eleRef.nativeElement.classList.add("active--");
    } else {
      this.popoverTarget.close();
      this.eleRef.nativeElement.classList.remove("active--");
    }
  }
}
